export default __webpack_public_path__ + "static/IN-PoE100_web_black_1-f986643ed3620e779c79bbd3dbda4b64.webp";